import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Objects } from '../../../util/objects';

@Component({
  selector: 'ngx-checkbox-column',
  template: `
    <div class="mt-1 d-flex align-items-center justify-content-center">
      <nb-checkbox 
        [checked]="params.getValue()"
        (checkedChange)="toggle($event)"
        [disabled]="isDisable"
        [attr.disable]="isDisable">
        {{ label }}
      </nb-checkbox>
    </div>`,
  encapsulation: ViewEncapsulation.None,
})
export class CheckboxColumn implements ICellRendererAngularComp {
  public params: ICellRendererParams;
  public status: string = 'basic';
  public useClick: boolean = false;
  public label: string;
  public disableRules: (params: ICellRendererParams) => boolean = (params) => false;

  constructor(private router: Router) {}

  refresh(params: ICellRendererParams): boolean {
    return true;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    
    this.disableRules = this.params['disableRule'] || null;
  }

  public get isDisable(): boolean {
    return this.disableRules ? this.disableRules(this.params) : false;
  }

  ngOnInit() {}

  toggle(event) {
    this.params.setValue(event);
    this.params.node.setDataValue(this.params.column.getId(),event);
  }
}